import {Badge, DialogBody, Table, Tabs} from "@chakra-ui/react"
import {Parts, UI} from "components"
import useBlackBnfReportList from "hooks/useBlackBnfReportList"
import moment from "moment"
import {useState, useMemo} from "react"
import useBlackBnfReportListBnf100 from "../../../../../hooks/useBlackBnfReportListBnf100";

export default function BlackBNF(props) {

    return (
        <UI.Dialog title="Relatório de Black BNF" size="xl" {...props}>
            <DialogBody>

                <Tabs.Root size="sm" defaultValue="100">
                    <Tabs.List>
                        <Tabs.Trigger value="100">BNF 100</Tabs.Trigger>
                        <Tabs.Trigger value="200">BNF 200</Tabs.Trigger>
                        <Tabs.Trigger value="400">BNF 400</Tabs.Trigger>
                    </Tabs.List>
                    <Tabs.Content value="100">
                        <Report type="100"/>
                    </Tabs.Content>
                    <Tabs.Content value="200">
                        <Report type="200"/>
                    </Tabs.Content>
                    <Tabs.Content value="400">
                        <Report type="400"/>
                    </Tabs.Content>
                </Tabs.Root>

            </DialogBody>
        </UI.Dialog>
    )
}

const Report = ({type, ...props}) => {
    const [term, setTerm] = useState()
    const list = useBlackBnfReportList(type === "100" ? null : type, term)
    const blackBnf100 = useBlackBnfReportListBnf100()

    const processedData = useMemo(() => {
        if (type === "100" && blackBnf100.data && blackBnf100.data.length > 0) {
            const item = blackBnf100.data
            const names = item.downline_names?.split(", ") || []
            const values = item.downline_values?.split(", ") || []

            const rows = names.map((name, index) => ({
                name: name,
                level: "1",
                total: parseFloat(values[index]) || 0,
                created_at: null
            }))

            if (term) {
                return rows.filter(row =>
                    row.name.toLowerCase().includes(term.toLowerCase())
                )
            }
            return rows
        }
        return list.data || []
    }, [type, blackBnf100.data, list.data, term])

    const columns = [
        {children: 'Nome'},
        {children: 'Nível'},
        {children: 'Compras', textAlign: 'right'},
        {children: '', textAlign: 'right'}
    ];
    const [downline, setDownline] = useState(false)

    return (
        <>
            <Parts.Dialog.Network.Downline
                open={!!downline} data={downline}
                onClose={() => setDownline(false)}
            />
            <UI.Searchable
                placeholder="Procurar pelo nome do consultor..."
                onChange={setTerm}
                disabled={type === "100" ? blackBnf100.isFetching : list.isFetching}
            />
            <UI.Table
                interactive onRowClick={setDownline}
                loading={type === "100" ? blackBnf100.isFetching : list.isFetching}
                loadingText="Carregando rede..."
                columns={columns} data={processedData} Row={Item}
            />
        </>
    )
}

const Item = ({ data, onClick = () => { }, ...props }) =>
{
    return (
        <Table.Row cursor="pointer" onClick={() => onClick(data)} {...props}>
            <Table.Cell textTransform="capitalize">{data.name}</Table.Cell>
            <Table.Cell><Badge>{data.level}</Badge></Table.Cell>
            <Table.Cell textAlign="right"><UI.Number.Amount value={data.total}/></Table.Cell>
            <Table.Cell textAlign="right" fontSize="xs">
                {data.created_at ? `Consultor desde ${moment(data.created_at).format('Y')}` : ""}
            </Table.Cell>
        </Table.Row>
    )
}